<template>
  <responsive-drawer-header :color="theme.appBar.other.color" :moduleUnreadCount="0" :hasDrawer="false">
    <template v-slot:left-module-title>{{ mx_moduleTitle }} </template>
    <template v-slot:left-subtitle>
      <span v-if="!hideWbTypeInHeader">{{ $t('module.wagenbuch.type.' + tab) }}</span>
    </template>

    <template v-slot:right>
      <v-btn-toggle v-if="mdAndUp && (wbTypes.length > 1 || hasEreignisse)" v-model="selectedTab" mandatory dense borderless @change="changeTab">
        <v-btn v-for="wbType in wbTypes" :key="wbType" :value="wbType" small text> {{ $t(`module.wagenbuch.type.${wbType}`) }} </v-btn>
        <v-btn v-if="hasEreignisse" value="ereignis" small text>
          {{ $t('module.wagenbuch.ereignisse') }}
        </v-btn>
      </v-btn-toggle>
      <FZSelector
        context="wagenbuch"
        :isMenuOpen="isFzSelectorOpen"
        @change="onSelectFz"
        @close="
          isFzSelectorOpen = false;
          openEreignis = false;
        "
      >
        <template v-slot:activator="{ on }">
          <v-icon><!--Placeholder because menu doesn't open without--></v-icon>
          <icon-text-btn
            icon="mdi-train-car"
            :text="vehicleText"
            :hint="vehicleText"
            @onClick="isFzSelectorOpen = true"
            :icon-color="theme.appBar.other.color"
            small
          />
        </template>
      </FZSelector>
      <div v-show="smAndDown">
        <v-menu style="min-width: 250px" left bottom close transition="slide-y-transition" offset-y dense close-on-click close-on-content-click>
          <template v-slot:activator="{ on, attrs }">
            <v-btn x-small :color="color" fab class="d-flex" icon v-bind="attrs" v-on="on">
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>

          <div class="background">
            <v-list-item ripple>
              <v-list-item-content v-for="wbType in wbTypes" :key="wbType" class="cursor-pointer" @click="selectedTab = wbType">
                {{ $t(`module.wagenbuch.type.${wbType}`) }}
              </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="hasEreignisse" ripple>
              <v-list-item-content class="cursor-pointer" @click="selectedTab = 'ereignis'">
                {{ $t('module.wagenbuch.ereignisse') }}
              </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
            <v-subheader class="mt-4">{{ $t('module.wagenbuch.typ.new_entry.long') }}</v-subheader>
            <new-entry-list-items @click="onNewEntryClick" />
          </div>
        </v-menu>
      </div>
      <div v-show="mdAndUp">
        <v-menu v-model="schadenMenu" eager offset-y>
          <template v-slot:activator="{ on }">
            <v-icon style="position: absolute; top: 60px"><!--Placeholder because menu doesn't open without--></v-icon>
            <icon-text-btn
              icon="mdi-plus"
              :icon-color="theme.appBar.other.color"
              :text="$t('module.wagenbuch.typ.new_entry')"
              :hint="$t('module.wagenbuch.typ.new_entry')"
              small
              @onClick="schadenMenu = true"
            />
          </template>

          <new-entry-list-items @click="onNewEntryClick" />
        </v-menu>
      </div>
      <v-dialog v-model="fzConfirmationDialog" max-width="420">
        <v-card>
          <div v-if="wbTypes.includes(activeEreignis)">
            <v-card-title class="text-h5"> {{ $t(`module.wagenbuch.type.${activeEreignis}.create`) }} </v-card-title>
            <v-card-text v-if="!!vehicle">{{ $t('module.wagenbuch.type.' + activeEreignis + '.create.for', { fzName: vehicleText }) }}</v-card-text>
            <v-card-text v-else>{{ $t('module.wagenbuch.kein_fahrzeug_ausgewaehlt') }}</v-card-text>
          </div>
          <div v-else>
            <v-card-title class="text-h5"> {{ $t(`module.wagenbuch.type.ereignis.create`) }} </v-card-title>
            <v-card-text v-if="!!vehicle">{{ $t('module.wagenbuch.type.ereignis.create.for', { fzName: vehicleText }) }}</v-card-text>
            <v-card-text v-else>{{ $t('module.wagenbuch.kein_fahrzeug_ausgewaehlt') }}</v-card-text>
          </div>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              text
              @click="
                fzConfirmationDialog = false;
                schadenMenu = false;
                isFzSelectorOpen = true;
                openEreignis = true;
              "
            >
              {{ $t('module.wagenbuch.anderes_fahrzeug') }}
            </v-btn>
            <v-btn
              text
              :disabled="!vehicle"
              :to="wbTypes.includes(activeEreignis) ? `/wagenbuch-schaden/${activeEreignis}/${fzId}` : `/wagenbuch-ereignis/${fzId}?name=${activeEreignis}`"
            >
              {{ $t('label.yes') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
  </responsive-drawer-header>
</template>

<script>
import index from './index';
import { mapState, mapMutations } from 'vuex';
import common from '@/mixins/common';
import dateTimeMixin from '@/mixins/dateTimeMixin';
import IconTextBtn from '@/components/buttons/IconTextBtn.vue';
import FZSelector from './wb-config/FZSelector.vue';
import ResponsiveDrawerHeader from '@/layouts/ResponsiveDrawerHeader.vue';
import NewEntryListItems from './NewEntryListItems.vue';
import configMixin from '@/mixins/configMixin';
import vehicleMixin from '@/mixins/vehicleMixin';

export default {
  components: { FZSelector, ResponsiveDrawerHeader, IconTextBtn, NewEntryListItems },
  name: 'WagenbuchHeader',
  mixins: [common, configMixin, dateTimeMixin, vehicleMixin],

  data() {
    return {
      isFzSelectorOpen: false,
      schadenMenu: false,
      fzTypIndex: 0,
      fzConfirmationDialog: false,
      activeEreignis: undefined,
      openEreignis: false, // Redirect to "Schaden" after different vehicle has been chosen,
      selectedTab: this.$route.query.tab || this.tab,
    };
  },
  mounted() {
    if (!this.$route.query.tab) {
      this.changeTab('mangel');
    }
  },
  computed: {
    ...mapState('wagenbuch', ['fzByTyp', 'tab', 'ereignisse']),
    color() {
      return this.theme.appBar.other.color;
    },
    vehicleText() {
      return this.vehicle ? this.vehicle.fzName : this.$t('noVehicleSelection');
    },
    moduleConfig() {
      return this.getModuleConfig(index.moduleType, this.$route.params.instance);
    },
    wbTypes() {
      return this.moduleConfig.types ? this.moduleConfig.types.split(',') : ['mangel'];
    },
    hideWbTypeInHeader() {
      return this.moduleConfig.hideWbTypeInHeader ? true : false;
    },
    hasEreignisse() {
      return this.ereignisse.length > 0;
    },
  },

  methods: {
    ...mapMutations('wagenbuch', ['setSelectedFzId']),
    changeTab(tab) {
      console.debug('changeTab', tab);

      if (this.$route.query.tab !== tab) {
        this.$router.push({ query: { ...this.$route.query, tab: tab } });
      }
      this.selectedTab = this.$route.query.tab;
    },

    onNewEntryClick(ereignisName) {
      console.debug('onNewEntryClick', ereignisName);
      this.activeEreignis = ereignisName;
      this.fzConfirmationDialog = true;
    },
    onSelectFz(vehicle) {
      const currentParams = this.$route.params;
      console.debug(`onSelectedFz vehicle=${JSON.stringify(vehicle, null, 2)}`, 'route=', this.$route.name, JSON.stringify(currentParams, null, 2));
      // this.selectedFz = vehicle.fzName;
      if (vehicle.id) this.setSelectedFzId(vehicle.id);

      if (this.isFzSelectorOpen && this.activeEreignis) {
        // Vehicle selected after clicking create "Schaden/Ereignis" without a selected vehicle or after switching vehicle
        // Start assistant directly
        if (this.wbTypes.includes(this.activeEreignis)) {
          this.$router.push({ name: 'schadenformular', params: { wbType: this.activeEreignis, fzId: vehicle.id } });
        } else {
          this.$router.push({ name: 'ereignis', params: { fzId: vehicle.id }, query: { name: this.activeEreignis } });
        }
      } else {
        // only vehicle selected
        const route = { name: this.$route.name, params: { wbType: currentParams.wbType || this.wbTypes[0], fzId: vehicle.id }, query: this.$route.query };
        console.debug(`route=${JSON.stringify(route, null, 2)}`);
        this.$router.push(route);
      }
    },
  },
  watch: {
    selectedTab(newValue, oldValue) {
      console.debug(`selectedTab changed from ${oldValue} to ${newValue}`);
      if (newValue !== oldValue) {
        this.changeTab(newValue);
      }
    },
  },
};
</script>

<style scoped>
.fz-menu {
  background-color: #fff;
}

.cursor-pointer {
  cursor: pointer;
}
</style>
